/**
 *
 * DevicePreview
 *
 */

import React from 'react';
import { toRgba } from 'utils/helpers';
import blurredPlaceholder from './placeholder-blurred.png';
import placeholder from './placeholder.png';
import classic from './classic.gif';
import boomerang from './boomerang.gif';
import ipad from './ipad.svg';
import browser from './browser.png';
import still from './still.png';
import storyVideo from './story-video.gif';
import standard from './standard.png';
import blackAndWhite from './b&w.gif';
import glitch from './glitch.gif';
import {
  PreviewScreen,
  BackgroundImg,
  LogoImg,
  LogoWrapper,
  Title,
  ButtonWrapper,
  PlaceholderWrapper,
  PlaceholderText,
  BrowserPreviewScreen,
  Headline,
  GalleryButton,
  GalleryCopyWrapper,
  GalleriesListWrapper,
} from './styledComponents';

import Device, { Device2 } from 'components/Device';
import StartButton from 'components/Icon/StartButton';
import Logo from '../Logo';
import { Browser } from '../Device';

const PreviewPlaceholder = ({ isProDevice }) => !isProDevice
  ? (
    <PlaceholderWrapper>
      <PlaceholderText>
        LOGO
    </PlaceholderText>
    </PlaceholderWrapper>
  )
  : (
    <Logo scale={4} fill="white" />
  );

const GalleriesPreview = () => (
  <GalleriesListWrapper>
    {[...Array(6).keys()].map(idx => (
      <img key={idx} src={placeholder} />
    ))}
  </GalleriesListWrapper>
);

const DevicePreview = ({ backgroundColor="#555555", overlayImage, logoImage, type }) => {
  const bgRGBA = !!backgroundColor && toRgba(backgroundColor);
  const isProDevice = type === 'pro';
  const background = !!overlayImage
    ? [`url(${blurredPlaceholder})`, 'center']
    : !!bgRGBA
      ? (isProDevice
        ? [`linear-gradient(${bgRGBA} 0%, ${bgRGBA} 100%)`, 'center', `url(${blurredPlaceholder})`,
          "center"]
        : [`linear-gradient(${bgRGBA} 0%, ${bgRGBA} 100%)`
          , `url(${blurredPlaceholder})`
          , 'center'
        ])
      : (isProDevice ? ['linear-gradient(rgba(42, 42, 42, .88) 0%, rgba(42,42,42,.88) 100%)'
        , `url(${blurredPlaceholder})`
        , 'center'
      ] : ['linear-gradient(135deg, rgba(214,0,0,.88) 0%, rgba(89,0,195,.88) 100%)'
        , `url(${blurredPlaceholder})`
        , 'center'
      ]);
  const DeviceContainer = isProDevice ? Device2 : Device;

  return (
    <DeviceContainer>
      <PreviewScreen style={{ height: '100%', background }}>
        {overlayImage && <BackgroundImg className={isProDevice ? 'pro' : ''} src={overlayImage} alt='logo' />}
        <LogoWrapper>
          {logoImage
            ? <LogoImg src={logoImage} alt='logo' />
            : <PreviewPlaceholder isProDevice={isProDevice} />
          }
        </LogoWrapper>
        {!isProDevice && (
          <Title>
            PHOTO BOOTH EXPERIENCE
          </Title>
        )}
        <ButtonWrapper className={isProDevice ? 'pro' : ''}>
          <StartButton />
        </ButtonWrapper>
      </PreviewScreen>
    </DeviceContainer>
  );
}

const GalleryPreview = ({ backgroundColor, logoImage, headline, subHeadline, buttonText }) => {
  const bgRGBA = !!backgroundColor && toRgba(backgroundColor, 1);

  return (
    <Browser>
      <BrowserPreviewScreen style={{ height: '94%', backgroundColor: bgRGBA }}>
        <GalleryCopyWrapper>
          {logoImage
            ? <img src={logoImage} alt='logo' width={65} height={40} />
            : <Logo scale={1.2} fill="white" />
          }
          <Headline>{headline}</Headline>
          <Headline className='sub'>{subHeadline}</Headline>
          {buttonText && <GalleryButton><label>{buttonText}</label></GalleryButton>}
        </GalleryCopyWrapper>
        <GalleriesPreview />
        <GalleriesPreview />
      </BrowserPreviewScreen>
    </Browser>
  );
}

export default DevicePreview;
export {
  blurredPlaceholder,
  placeholder,
  classic,
  boomerang,
  ipad,
  browser,
  GalleryPreview,
  still,
  storyVideo,
  standard,
  blackAndWhite,
  glitch
};



// WEBPACK FOOTER //
// ./src/components/DevicePreview/index.js